import { Map } from 'immutable';

import { Loadable, LoadableFactory } from '®shared/data';
import { PageableItems } from '®shared/reading-list/models';

import {
  PageableItemsActionTypes,
  PageableItemsActions,
} from './pageable-items.actions';

export function loadableItemPagesReducer(
  state: Map<number, Loadable<PageableItems>>,
  action: PageableItemsActions,
): Map<number, Loadable<PageableItems>> {
  switch (action.type) {
    case PageableItemsActionTypes.ITEM_PAGE_INITIALISED: {
      return action.payload.pageOffsets.reduce(
        (soFar, offset) =>
          soFar.set(offset, LoadableFactory.loading<PageableItems>()),
        Map<number, Loadable<PageableItems>>(),
      );
    }
    case PageableItemsActionTypes.ITEM_PAGE_LOADED: {
      return state.set(
        action.payload.pageOffset,
        LoadableFactory.loaded(action.payload),
      );
    }
    case PageableItemsActionTypes.ITEM_PAGE_LOADING_FAILED: {
      return state.set(
        action.payload.pageOffset,
        LoadableFactory.errored(action.payload.error),
      );
    }
    default: {
      return state;
    }
  }
}
